import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface INotification {
  notificationId?: number;
  id?: number;
  title?: string;
  message?: string;
  body?: string;
  description?: string;
  createdAt?: string;
  isRead?: boolean;
  read?: boolean;
  status?: string;
  [key: string]: any;
}

export const isNotificationRead = (n: INotification): boolean => {
  if (n.isRead !== undefined && n.isRead !== null) return !!n.isRead;
  if (n.read !== undefined && n.read !== null) return !!n.read;
  if (typeof n.status === "string") {
    const normalized = n.status.trim().toLowerCase();
    if (["read", "seen", "viewed"].includes(normalized)) return true;
    if (["unread", "new", "unseen"].includes(normalized)) return false;
  }

  return false;
};

export const getUnreadCount = (notifications: Array<INotification>): number => {
  return notifications.filter((n) => !isNotificationRead(n)).length;
};

const getAll = () => {
  return Axios.get<any>(ENDPOINTS.notifications.all);
};

const getByUserAndType = (userId: number | string, type: string = "ALL") => {
  return Axios.get<any>(ENDPOINTS.notifications.byUserAndType(userId, type));
};

const getByType = (type: string) => {
  return Axios.get<any>(ENDPOINTS.notifications.byType(type));
};

const getForTab = (userId: number | string, type: string) => {
  const normalized = (type || "ALL").toUpperCase();
  if (normalized === "ORDER" || normalized === "PRODUCT") {
    return getByType(normalized);
  }
  return getByUserAndType(userId, normalized);
};

export interface ICreateNotification {
  title: string;
  message: string;
  notificationDate?: string | null;
  status?: number;
  uri?: string;
  notificationType?: number;
  isRead?: number;
  imageUrl?: string;
  promotionStartDate?: string | null;
  promotionEndDate?: string | null;


  userId?: number | null;
}

const toLocalDateTime = (dateOnly?: string | null): string | null => {
  if (!dateOnly) return null;
  return dateOnly.length === 10 ? `${dateOnly}T00:00:00` : dateOnly;
};

const create = (data: ICreateNotification) => {
  return Axios.post<any>(ENDPOINTS.notifications.create, {
    ...data,
    notificationDate: toLocalDateTime(data.notificationDate),
    promotionStartDate: toLocalDateTime(data.promotionStartDate),
    promotionEndDate: toLocalDateTime(data.promotionEndDate),
  });
};

const NotificationService = {
  getAll,
  getByUserAndType,
  getByType,
  getForTab,
  create,
};

export default NotificationService;
